var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white max-w-5xl rounded-md shadow-md mx-auto my-12"},[_c('h1',{staticClass:"text-center p-4 text-xl text-gray-800"},[_vm._v(" Welcome to Carthike! Let's get started ")]),_c('OnboardingPlans')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }